// @ts-nocheck
import { Container, Card, CardBody, CardTitle, CardText, CardReadMore, Row, Col } from 'design-react-kit';
import React, { useState, useEffect, useContext } from 'react';
import ApiService from "../../../services/api";
import { LocalSettingsContext } from "services/local_settings";

const WidgetCategory = (props) => {
    
    const settings = useContext(LocalSettingsContext);

    const localSettings = settings.localSettings;

    const eventsParentCategorySlug = localSettings.events_parent_category === null ? 'novita' : localSettings.events_parent_category_data.slug

    const [ widget ] = useState(props.widget);

    const category_type = widget.data.category_type;

    const [ categories, setCategories ] = useState();
    const [ categoryTitle, setCategoryTitle ] = useState();
    const [ link, setLink ] = useState();

    let categoryList;

    const fetchCategories = async() => {
        const categoriesData = await ApiService.getCategoryList();
        switch(category_type) {
            case 'news':
                categoryList = categoriesData.filter(category => category.is_news === true);
                setCategories(categoryList);
                setCategoryTitle('Tutte le novità');
                setLink('/novita/');
                break;

            case 'events':
                let categoryArray = [];
                categoryList = categoriesData.filter(category => category.is_event === true);
                Promise.all(categoryList.map((category) => ApiService.getLatestEventsByCategory(category.id))).then((events) => {
                    events.forEach((event) => {
                        if(event.length > 0) {
                            categoryArray.push(event[0].category.id);
                        }
                    });
                    const categoryEvents = categoryList.filter(cat => categoryArray.includes(cat.id));
                    setCategories(categoryEvents);
                });
                setCategoryTitle('Tutto sugli Eventi');
                setLink(eventsParentCategorySlug === 'novita' ? '/novita/eventi/' : '/eventi/');
                break;

            case 'documents':
                categoryList = categoriesData.filter(category => category.is_document === true);                
                setCategories(categoryList);
                setCategoryTitle('Tutto i Documenti');
                setLink('/documenti-e-dati/');
                break;

            case 'places':
                categoryList = categoriesData.filter(category => category.is_place === true);
                setCategories(categoryList);
                setCategoryTitle('Tutto i Luoghi');
                setLink('/luoghi/');
                break;

            default:
                setCategories(categoryList);
        }
    }

    useEffect(() => {
        fetchCategories();
    }, []);    

    return <>
        <Container fluid className={widget.data.class + '-categories page-categories-content ps-0'}>
            <h2 className="mt-5">{categoryTitle}</h2>
            {categories && categories.length === 0 && 'Nessun risultato'}
            <Row>
            {categories && categories.map((category) =>                
                <Col xs='12' lg='4' className="mt-4" key={"key_categoryItem_" + category.id}>                    
                    <Card className="category-card border border-light shadow-sm">
                        <CardBody>
                            <CardTitle tag='h3' className='big-heading'>
                                <a href={link + category.slug + '/'} className="text-decoration-none me-2" title={category.name}>{category.name}</a>
                            </CardTitle>
                            <CardText>
                                {(category.description).replace(/(<([^>]+)>)/gi, "")}
                            </CardText>
                            <CardReadMore href={link + category.slug + '/'} text='Vai alla pagina' iconName='it-arrow-right' />
                        </CardBody>
                    </Card>
                </Col>
            )}
            
            </Row>
        </Container>
        </>;
}

export default WidgetCategory;